export default __webpack_public_path__ + "c5a0829bbbb3c9cfc684f0c64d0e0a8b.png";